import { OutputEmitterRef } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { BudgetViewComponent } from "../../budget/budget-view/budget-view.component";
import { CrmClientComponent } from "../../crm/crm-client/crm-client.component";
import { OrderComponent } from "../../main/order/order.component";
import { FolderDetailsComponent } from "../../folder/details/folder-details.component";
import { InvoiceDetailsComponent } from "../../invoice/details/invoice-details.component";
import { InventoryActionDetailsComponent } from "../../inventory/actions/details/inventory-action-details.component";
import { WorkDialogComponent } from "../../work/work-dialog/work-dialog.component";
import { getRouteForElement } from "../routes-utils";
import { Router } from "@angular/router";
import { OrderNotificationsComponent } from "../../main/order-notifications/order-notifications.component";
import { VehicleDetailsComponent } from "../../vehicles/vehicle-details/vehicle-details.component";

export interface GoToDetailsArgs {
  id: number;
  type: string;
  mode?: "modal" | "route";
  afterClosed?: OutputEmitterRef<void>;
  queryParams?: Record<string, unknown>;
  dialog?: MatDialog;
  router?: Router;
}

export function goToDetails({id, type, mode="modal", afterClosed, queryParams, dialog, router}: GoToDetailsArgs) {
  if (mode === "modal") {
    goToDetailsDialog(id, type, afterClosed, dialog);
  } else {
    goToDetailsRoute(id, type, queryParams, router);
  }
}

function goToDetailsDialog(id: number, type: string, afterClosed?: OutputEmitterRef<void>, dialog?: MatDialog) {
  const dialogParams = getDialogParamsFor(id, type);

  if (!dialogParams) return;

  dialog.open(
    dialogParams.component, 
    {...dialogParams.params, minWidth: "80%"}
  ).afterClosed().subscribe(() => {
    afterClosed?.emit();
  });
}

function goToDetailsRoute(id: number, type: string, queryParams: Record<string, unknown>, router: Router) {
  const route = getRouteForElement(type, id);
  if (route) {
    router.navigate(route, { queryParams });
  }
}

function getDialogParamsFor(id: number, type: string) {
  const params = mapTypeWithDialogParams(id)[type];
  if (!params) {
    console.error(`No dialog params found for type: ${type}`);
  }
  return params; 
}

const mapTypeWithDialogParams = (id: number) => ({
  Budget: {
    component: BudgetViewComponent,
    params: { data: {id} },
  },

  CheckIn: {
    component: OrderComponent,
    params: { data: id },
  },

  Client: {
    component: CrmClientComponent,
    params: { data: { id, type: 'Client'} },
  },

  Crm: {
    component: CrmClientComponent,
    params: { data: {id} },
  },

  'Crm::Booking': {
    component: CrmClientComponent,
    params: { data: {id} },
  },

  'Folder::InventoryAction::Pricing': {
    component: FolderDetailsComponent,
    params: { data: {folder: {id}} },
  },

  'InventoryAction::BuyOrder': {
    component: InventoryActionDetailsComponent,
    params: { data: {inventoryAction: {id}} },
  },

  'InventoryAction::Consume': {
    component: InventoryActionDetailsComponent,
    params: { data: {inventoryAction: {id}} },
  },

  'InventoryAction::Edit': {
    component: InventoryActionDetailsComponent,
    params: { data: {inventoryAction: {id}} },
  },

  'InventoryAction::Loss': {
    component: InventoryActionDetailsComponent,
    params: { data: {inventoryAction: {id}} },
  },

  'InventoryAction::Movement': {
    component: InventoryActionDetailsComponent,
    params: { data: {inventoryAction: {id}} },
  },

  'InventoryAction::Pricing': {
    component: InventoryActionDetailsComponent,
    params: { data: {inventoryAction: {id}} },
  },

  'InventoryAction::Return': {
    component: InventoryActionDetailsComponent,
    params: { data: {inventoryAction: {id}} },
  },

  'InventoryAction::Set': {
    component: InventoryActionDetailsComponent,
    params: { data: {inventoryAction: {id}} },
  },

  'InventoryAction::Stock': {
    component: InventoryActionDetailsComponent,
    params: { data: {inventoryAction: {id}} },
  },

  Invoice: {
    component: InvoiceDetailsComponent,
    params: { data: {invoice: {id}} },
  },

  'Invoice::CreditNote': {
    component: InvoiceDetailsComponent,
    params: { data: {invoice: {id}} },
  },

  'Invoice::Purchase': {
    component: InvoiceDetailsComponent,
    params: { data: {invoice: {id}} },
  },

  'Invoice::Sale': {
    component: InvoiceDetailsComponent,
    params: { data: {invoice: {id}} },
  },

  Order: {
    component: OrderComponent,
    params: { data: id },
  },

  OrderComment: {
    component: OrderComponent,
    params: { data: {id} },
  },

  OrderNotification: {
    component: OrderNotificationsComponent,
    params: { data: {order_id: id} },
  },

  Recall: {
    component: OrderComponent,
    params: { data: id },
  },

  UserAssignation: {
    component: WorkDialogComponent,
    params: { data: {id, type: 'WorkInstance'} },
  },

  Vehicle: {
    component: VehicleDetailsComponent,
    params: { data: {id, type: 'Vehicle'} },
  },

  WorkAssignation: {
    component: WorkDialogComponent,
    params: { data: {id, type: 'WorkInstance'} },
  },

  WorkInstance: {
    component: WorkDialogComponent,
    params: { data: {id, type: 'WorkInstance'} },
  },

  WorkRequest: {
    component: WorkDialogComponent,
    params: { data: {id, type: 'WorkInstance'} },
  },
});
